"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.StyledRadioCardMessage = exports.StyledRadioCardDescription = exports.StyledRadioCardLabel = exports.StyledRadioCardContent = exports.StyledRadioInput = exports.StyledRadioCardWrapper = exports.StyledLockIconWrapper = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./radio-card-group.types");
exports.StyledLockIconWrapper = theme_1.styled.div `
  width: 22px;
  height: 22px;
  position: absolute;
  top: ${({ hasIcon }) => (hasIcon ? '38px' : '16px')};
  left: 22px;
`;
exports.StyledRadioCardWrapper = theme_1.styled.label `
  width: 100%;
`;
exports.StyledRadioInput = theme_1.styled.input.attrs({
    type: 'radio',
}) `
  display: none;

  &:checked ~ div {
    ${({ disabled, theme, isCurrency, isBasicVersion }) => !disabled &&
    !isBasicVersion &&
    (0, theme_1.css) `
        border: 2px solid ${theme.colors.surface.brand};
        background-color: ${isCurrency
        ? theme.colors.surface.interactive['interactive-light']
        : 'transparent'};
      `}

    &:before {
      background-color: ${({ theme }) => theme.colors.surface.brand};
      border-color: ${({ theme }) => theme.colors.surface.brand};
    }

    ${({ disabled, isBasicVersion }) => disabled &&
    isBasicVersion &&
    (0, theme_1.css) `
        &:before {
          background-color: ${({ theme }) => theme.colors.neutral[70]};
          border-color: ${({ theme }) => theme.colors.neutral[70]};
        }
      `}
  }
  & ~ div:before {
    ${({ isHidden }) => isHidden
    ? (0, theme_1.css) `
            visibility: hidden;
            position: absolute;
            width: 0;
            height: 0;
          `
    : ''}
  }
`;
exports.StyledRadioCardContent = theme_1.styled.div `
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  position: relative;

  ${({ isBasicVersion, disabled, error, checked }) => isBasicVersion
    ? (0, theme_1.css) `
          padding-left: 32px;

          &:hover {
            &:before {
              border-color: ${({ theme }) => !disabled && !error && theme.colors.surface.brand};
            }
          }
          &:before {
            left: 0;
            top: 0;
          }
          &:after {
            left: 8px;
            top: 8px;
            background: ${({ theme }) => disabled && checked
        ? theme.colors.neutral[30]
        : theme.colors.neutral[0]};
          }
        `
    : (0, theme_1.css) `
          border: 2px solid ${({ theme }) => theme.colors.neutral[30]};
          border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)`; }};
          padding: 16px 16px 16px 52px;
          transition: border 0.2s ease-out;

          &:hover {
            border-color: ${({ theme }) => theme.colors.neutral[50]};
          }
          &:before {
            left: 16px;
            top: ${({ icon }) => (icon ? '38px' : '16px')};
          }
          &:after {
            top: ${({ icon }) => (icon ? '46px' : '24px')};
            left: 24px;
            background: ${({ theme }) => theme.colors.neutral[0]};
          }
        `};

  &:before {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    border: 2px solid ${({ theme }) => theme.colors.neutral[50]};
    border-radius: 50%;
    box-sizing: border-box;
    transition: background-color 0.2s ease-out, border-color 0.2s ease-out;
  }

  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  ${({ disabled, isBasicVersion }) => disabled &&
    !isBasicVersion &&
    (0, theme_1.css) `
      &:before {
        display: none;
      }

      &:after {
        display: none;
      }
    `};

  ${({ icon }) => icon &&
    (0, theme_1.css) `
      display: flex;
      align-items: center;
      justify-content: space-between;
    `}

  ${({ isCurrency }) => isCurrency
    ? (0, theme_1.css) `
          border: 2px solid ${({ theme }) => theme.colors.neutral[30]};
          padding: 4px 8px;
          &:after {
            content: none;
          }
        `
    : null};

  ${({ error, disabled, isBasicVersion }) => error &&
    !disabled &&
    !isBasicVersion &&
    (0, theme_1.css) `
      border: 2px solid ${({ theme }) => theme.colors.accent.error.normal};
    `}

  ${({ error, disabled }) => error &&
    !disabled &&
    (0, theme_1.css) `
      &:before {
        border-color: ${({ theme }) => theme.colors.accent.error.normal};
      }
    `}
`;
exports.StyledRadioCardLabel = theme_1.styled.div `
  ${({ isCurrency }) => isCurrency ? theme_1.typography.regular14 : theme_1.typography.medium16};
  ${({ isCurrency }) => isCurrency
    ? (0, theme_1.css) `
          white-space: nowrap;
        `
    : ''}
  display: block;
  color: ${({ disabled, theme }) => disabled ? theme.colors.text.secondary : theme.colors.text.primary};

  ${theme_1.media.desktop} {
    ${({ isCurrency, isBasicVersion }) => !isCurrency && !isBasicVersion && theme_1.typography.medium16};
  }
  ${({ textAlign }) => textAlign &&
    (0, theme_1.css) `
      text-align: ${textAlign};
    `}

  ${({ isBasicVersion }) => isBasicVersion &&
    (0, theme_1.css) `
      ${theme_1.typography.regular18}
      line-height: 26px;
    `}

  width: 100%;
`;
exports.StyledRadioCardDescription = theme_1.styled.span `
  ${theme_1.typography.regular16};
  display: block;
  margin-top: 4px;
  color: ${({ theme, error, isBasicVersion }) => isBasicVersion && error
    ? theme.colors.text.error
    : theme.colors.text.secondary};
`;
exports.StyledRadioCardMessage = theme_1.styled.span `
  ${theme_1.typography.regular14};
  display: block;
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledIcon = theme_1.styled.span ``;
